export default {
  id: '499d46874f',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=home><!-- Toolbar--><div class="toolbar toolbar-bottom"><div class=toolbar-inner><div class=col-10></div><a href=javascript:; class="col-20 link button button-fill button-rounded btnLerCodigo p-2 active"><i class="fas fa-2x fa-qrcode"></i></a> <a href=/codigo/ class="col-20 link button button-fill button-rounded p-2"><i class="fas fa-2x fa-ticket-alt"></i></a> <a href=/leituras/ class="col-20 link button button-fill button-rounded p-2"><i class="fas fa-2x fa-list"></i></a> <a href=/logout/ class="col-20 link button button-fill button-rounded p-2"><i class="fas fa-2x fa-sign-out-alt"></i></a><div class=col-10></div></div></div><!-- Scrollable page content--><div class=page-content><div class=bock><div class=text-align-center style="margin-top: 50px;"><img src=./static/images/logo.png width=85% alt=""></div><h3 class=text-align-center>Utilize os menus no<br>rodapé para realizar o<br>CHECK-IN dos visitantes:</h3><h4 class=text-align-center><i class="fas fa-qrcode"></i> Ler o Código</h4><h4 class=text-align-center><i class="fas fa-ticket-alt"></i> Digitar o Código</h4><div class=text-align-center><small class=expositornome></small></div><div class=text-align-center><small class=versao-app></small></div><hr></div></div></div>';
      return r;
    }(this);
  },
  styleScoped: false
};